import { chain } from "lodash";

export const getSelectedIds = function(list) {
    if (list.hasOwnProperty("characteristics")) return;

    return chain(list)
        .map(e => e.optionGroups)
        .flatten()
        .map(e => e.options)
        .flatten()
        .filter(e => {
            return e !== null && e.isSelected && e.namePicked !== "";
        })
        .map(e => e.id)
        .value();
};

export const getDefaultSelectedOptions = function(list) {
    return chain(list)
        .map(e => e.optionGroups)
        .flatten()
        .map(e => e.options)
        .flatten()
        .filter(e => {
            return e !== null && e.defaultSelected && e.namePicked !== "";
        })
        .value();
};

export const getOptionsWithId = function(dropdown, ids) {
    return chain(dropdown)
        .map(e => e.optionGroups)
        .flatten()
        .map(e => e.options)
        .flatten()
        .filter(e => {
            return ids.indexOf(e.id) >= 0;
        })
        .value();
}

// Local Storage with Expiration
export const storageHelper = {
    save: function(key, jsonData, minutes, session = false) {
        if (typeof Storage == "undefined") {
            return false;
        }
        var record = {
            value: JSON.stringify(jsonData),
            timestamp: new Date().getTime() + (minutes * 60 * 1000)
        };
        if (session) {
            sessionStorage.setItem(key, JSON.stringify(record));
        } else {
            localStorage.setItem(key, JSON.stringify(record));
        }
        return jsonData;
    },
    load: function(key, session) {
        if (typeof Storage == "undefined") {
            return false;
        }
        var record = session ? JSON.parse(sessionStorage.getItem(key)) : JSON.parse(localStorage.getItem(key));
        if (!record) {
            return undefined;
        }
        return (
            new Date().getTime() < record.timestamp && JSON.parse(record.value)
        );
    },
    remove: function(key, session) {
        if (session) {
            sessionStorage.removeItem(key);
        } else {
            localStorage.removeItem(key);
        }
    }
};



// WEBPACK FOOTER //
// ./src/tools/tools.js